import React, { createContext, useContext, useState } from 'react';

type PresentationContextType = {
  isPresenting: boolean;
  setIsPresenting: (isPresenting: boolean) => void;
  isPreview: boolean;
  setIsPreview: (isPreview: boolean) => void;
};

const PresentationContext = createContext<PresentationContextType>({
  isPresenting: false,
  setIsPresenting: () => {},
  isPreview: false,
  setIsPreview: () => {},
});

export const PresentationProvider = ({ children }: { children: React.ReactNode }) => {
  const [isPresenting, setIsPresenting] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  return (
    <PresentationContext.Provider value={{ isPresenting, setIsPresenting, isPreview, setIsPreview }}>
      {children}
    </PresentationContext.Provider>
  );
};

export const usePresentationContext = () => useContext(PresentationContext);
